import { listByProducts } from '@/apis/brand'
import { useRtfix } from '@/store'
import { confirmLogin } from '@/util/useConfirm'
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

// authStatus是用户有没有授权 0和1
// brandStatus是品牌的状态 0草稿 1未发布 2已发布
// hasReleased是这个品牌之前有没有发布过 0和1
// isAuthorizing

export default () => {
  const router = useRouter()
  const store = useStore()
  const productCode = useRoute().params?.id?.toString() ?? ''
  const needAuth = ref(0)
  let brand = ''
  if (store.getters.isLogin) {
    listByProducts({ productCodeList: [productCode] }).then((res:any) => {
      if (res.success) {
        const data = res.data[0]
        if (data?.brandInfo?.brandId) {
          let value = (data.brandInfo.authStatus === 0 && data.brandInfo.hasReleased) ? 1 : 0
          if (value) {
            if (data.brandInfo.isAuthorizing) {
              value = 2
            } else if (data.brandInfo.brandStatus !== 2) {
              value = 3
            }
          }
          needAuth.value = value
          brand = data?.brandInfo?.brandId
        }
      }
    })
  }
  const toAuth = async () => {
    const token = store.getters.token
    const curShop = store.getters.curShop
    if (!token && !curShop) {
      store.commit('status/onLogin', () => {
        store.commit('status/onLogin', null)
      })
      return
    }
    if (!curShop) {
      store.commit('status/toCreateShop', true)
      return
    }
    confirmLogin(async () => {
      router.push(useRtfix('BrandAuth', { query: { brand } }))
    })
  }
  return [needAuth, toAuth] as const
}

export const brandStatus = () => {

}
